export default __webpack_public_path__ + "static/1169-7f197bd922a7922afea3d68fac20234f.gif";